export default __webpack_public_path__ + "static/my-radar-logo-dd0086044173707f8d4c5cfbf68d8ba8.png";